import { Box, Text, Tooltip } from '@frontend/legacy-components';

import {
  FeatureFlagType,
  FeatureFlagData,
  FeatureFlagTierSetting,
} from 'modules/common/drawers/featureFlagDrawer/types';

import { getBooleanTierIcon, getBooleanTierStatus } from '../FormFieldRow';

type TierCellProps = {
  tierSetting:
    | FeatureFlagTierSetting
    | { default?: number | string; upsell: boolean }
    | undefined;
  tierName: string;
  type: FeatureFlagData['type'];
  contracted: boolean;
};

export const TierCell = ({
  tierSetting,
  tierName,
  type,
  contracted,
}: TierCellProps) => {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      verticalAlign="middle"
    >
      {type === FeatureFlagType.Boolean ? (
        tierSetting === undefined ? (
          <Tooltip label={`${tierName}: as required by configuration`}>
            <Box
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              boxSize={3}
              flexShrink={0}
            >
              <Box
                width="18px"
                height="18px"
                borderRadius="full"
                bg="page.plateMedium"
              />
            </Box>
          </Tooltip>
        ) : (
          <Tooltip
            label={`${tierName}: ${getBooleanTierStatus(
              tierSetting,
              contracted,
            )}`}
          >
            {getBooleanTierIcon(tierSetting, contracted)}
          </Tooltip>
        )
      ) : tierSetting &&
        typeof tierSetting === 'object' &&
        tierSetting.default !== undefined ? (
        <Tooltip
          label={
            tierSetting.upsell
              ? 'Upsell for more'
              : `${tierName}: ${tierSetting.default}`
          }
        >
          <Text
            fontSize="sm"
            color={tierSetting.upsell ? 'alert.warning' : undefined}
            fontWeight={tierSetting.upsell ? 'medium' : undefined}
          >
            {String(tierSetting.default)}
          </Text>
        </Tooltip>
      ) : (
        <Tooltip label={`${tierName}: as required by configuration`}>
          <Box
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            boxSize={3}
            flexShrink={0}
          >
            <Box
              width="18px"
              height="18px"
              borderRadius="full"
              bg="page.plateMedium"
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
